<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-02-23 11:05:55
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-04-07 10:13:54
 * @FilePath: \qctsw-vue\packages\app\src\pages\publish\components\ModalPublishComplete.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { addHost } from '@qctsw/common'

const _props = withDefaults(defineProps<{
  modelValue: boolean
}>(), {

})

const emits = defineEmits(['update:modelValue'])
const isSite = useRoute().query.isSite || false as string | undefined | boolean
const { showDialog, qrcodeUrl, checkUserFocusMp } = useFocusMP()
checkUserFocusMp()

const router = useRouter()
useActivatedWatch(() => [
  router?.beforeEach(() => {
    emits('update:modelValue', false)
  }),
])
</script>

<template>
  <NModal :show="modelValue" @update:show="(value) => emits('update:modelValue', value)">
    <n-card
      style="width: 600px"
      title="投诉发表成功"
      size="huge"
      :bordered="false"
      role="dialog"
      aria-modal="true"
      closable
      @close="emits('update:modelValue', false)"
    >
      <div class="flex flex-col items-center justify-between">
        <div class="flex flex-col items-center py-6">
          <div class="text-red-5 text-center pb-6 text-4.5">
            投诉发表成功
          </div>
          <template v-if="showDialog">
            <div class="text-3.5 text-center pb-sm">
              关注汽车投诉网公众号，随时查看投诉进度
            </div>
            <img v-if="qrcodeUrl" class="code flex-shrink-0 object-contain" :src="addHost(qrcodeUrl) || ''">
            <img v-else class="code flex-shrink-0 object-contain" src="/images/qctsw_open_qrcode.jpg">
          </template>
          <div class="text-center">
            <i v-if="!showDialog" class="i-custom-undraw-mail-sent?bg text-30" />
            <div class="text-3.5 mt-2">
              投诉相关进展、企业回复等消息将会同步通过微信消息通知您
            </div>
          </div>
        </div>
        <div class="pb-6">
          <NuxtLink :to="isSite ? $route.query.redirectUrl as string || 'https://qiche.cqszzs.com/' : '/'" class="mx-8">
            <button class="px-10 btn-primary">
              返回首页
            </button>
          </NuxtLink>
          <NuxtLink to="/user/userInfo" class="mx-8">
            <button class="px-10 btn-success">
              个人中心
            </button>
          </NuxtLink>
        </div>
      </div>
    </n-card>
  </NModal>
</template>

<style lang="scss" scoped>
  .code {
  width: 200px;
  height: 200px;
}
</style>
